const STORAGE_PREFIX = 'upv-export-job-';

export interface PendingExportJob {
  jobId: string;
  filename: string;
  startedAt: number;
}

export function savePendingExportJob(ensayoId: string, job: PendingExportJob): void {
  sessionStorage.setItem(`${STORAGE_PREFIX}${ensayoId}`, JSON.stringify(job));
}

export function readPendingExportJob(ensayoId: string): PendingExportJob | null {
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${ensayoId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PendingExportJob;
    if (!parsed.jobId || !parsed.filename) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingExportJob(ensayoId: string): void {
  sessionStorage.removeItem(`${STORAGE_PREFIX}${ensayoId}`);
}
